import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Category from "./Category";

@Model()
class YoutubeChannel extends ApplicationRecord {
  static jsonapiType = "youtube_channels";

  @Attr() audience: number;

  @BelongsTo() category: Category;

  @Attr() categoryId: number;

  @Attr() description: string;

  @Attr() enabled: boolean;

  @BelongsTo() location: Location;

  @Attr() locationId: number;

  @Attr() logoUrl: string;

  @Attr() name: string;

  @Attr() platformLogo: string;

  @Attr() timeZone: string;

  @Attr() url: string;

  @Attr() youtubeId: string;
}

export default YoutubeChannel;
